export default {
  "name": "Did she walk upright?",
  "slug": "did-she-walk-upright",
  "path": "/did-she-walk-upright",
  "componentName" : "DidSheWalkUpright",
  "category": "Projects",
  "parent": false,
  "isPublic": true
}